import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const ChapterStatusFilter = ({
  filterValue,
  updateFilters,
  disabled = false,
}) => {
  return (
    <FormControl fullWidth={true} variant="outlined" size="small">
      <InputLabel id="chapter_status">Chapter Status</InputLabel>
      <Select
        labelId="select-label"
        id="select"
        disabled={disabled}
        fullWidth={true}
        value={filterValue}
        label="Chapter Status"
        onChange={(event) => updateFilters(event.target.value)}
      >
        <MenuItem key={'all'} value={'all'}>
          {'All'}
        </MenuItem>
        <MenuItem key={'active'} value={'active'}>
          {'Active'}
        </MenuItem>
        <MenuItem key={'new'} value={'new'}>
          {'New'}
        </MenuItem>
        <MenuItem key={'disbanded'} value={'disbanded'}>
          {'Disbanded'}
        </MenuItem>
        <MenuItem key={'merged'} value={'merged'}>
          {'Merged'}
        </MenuItem>
      </Select>
    </FormControl>
  );
};

export default ChapterStatusFilter;
